const ENDPOINTS = ["https://overpass-api.de/api/interpreter", "https://overpass.kumi.systems/api/interpreter"];

const classify = (tags) => {
  const name = (tags.name || "").toLowerCase();
  const words = name.split(/\s+/);
  const { amenity, office } = tags;
  if (amenity === "police" || name.includes("fiscal") || name.includes("ministerio público")) return "fiscalia";
  if (name.includes("profeco")) return "profeco";
  if (words.includes("sat") || /hacienda|tesorer|finanzas|recaudaci/.test(name) || office === "tax") return "finanzas";
  if (/turismo|consulado|embajada/.test(name) || amenity === "embassy" || office === "diplomatic") return "turismo";
  if (/registro civil|licencia|predial|catastro/.test(name) || words.includes("ine") || amenity === "courthouse") return "registro";
  if (amenity === "townhall" || office === "government") return "gobierno";
  return null;
};

const toOffice = (el) => {
  const tags = el.tags || {};
  const category = tags.name && classify(tags);
  const lat = el.lat ?? el.center?.lat;
  const lng = el.lon ?? el.center?.lon;
  if (!category || lat == null) return null;
  const street = [tags["addr:street"], tags["addr:housenumber"]].filter(Boolean).join(" ");
  return {
    id: `osm-${el.type}-${el.id}`,
    name: tags.name,
    category,
    address: street || tags["addr:full"] || "",
    municipality: tags["addr:city"] || "",
    state: tags["addr:state"] || "",
    lat,
    lng,
    hours: tags.opening_hours || "Consultar horario",
    phone: tags.phone || tags["contact:phone"] || "",
    modality: "presencial",
    website: tags.website || tags["contact:website"] || "",
    source: "osm",
  };
};

export const fetchNearbyOsm = async (lat, lng) => {
  const key = `hg-osm2-${lat.toFixed(2)}-${lng.toFixed(2)}`;
  const cached = sessionStorage.getItem(key);
  if (cached) return JSON.parse(cached);
  const sel = `["amenity"~"townhall|police|courthouse|embassy"](around:7000,${lat},${lng});`;
  const off = `["office"~"government|tax|diplomatic"](around:7000,${lat},${lng});`;
  const q = `[out:json][timeout:20];(node${sel}way${sel}node${off}way${off});out center 80;`;
  for (const url of ENDPOINTS) {
    try {
      const res = await fetch(url, { method: "POST", body: new URLSearchParams({ data: q }), signal: AbortSignal.timeout(10000) });
      if (!res.ok) continue;
      const { elements = [] } = await res.json();
      const items = elements.map(toOffice).filter(Boolean);
      sessionStorage.setItem(key, JSON.stringify(items));
      return items;
    } catch {
      /* try next endpoint */
    }
  }
  return [];
};
